<p *ngIf="!isLoaded"><em>Cargando...</em></p>
<div *ngIf="isLoaded">
  <div id="pnlInformativo">
    <div class="dvGral">
      <div style="display:inline;">
        <span class="lblTituloPnl">Documentos</span>
      </div>
      <div style="display:inline;float:right" *ngIf="((varIdPerfil===1 || varIdPerfil===4) && this.varIdAccionCarpertaEstCredito !== 1)">
        <button type="button" (click)="importarArchivo()" mat-raised-button>Subir Documento</button>
      </div>
    </div>
  </div>
  <div class="pnlGroupingClaro">
    <div class="dvRowDocs" *ngFor="let documento of lstDocumentos | async">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <!--[ngClass]="(varEstPermiteImportar)?'col-1':'col-2'"-->
            <a class="col-1" (click)='VistaPrevia(documento)'>
              <img src="{{documento.strUrlImagenDoc}}" />
            </a>
            <a *ngIf="((varIdPerfil===1 || varIdPerfil===4) && varIdAccionCarpertaEstCredito === 2)" class="col-1" (click)='Elimina(documento)'>
              <img src="assets/img/basura.png" />
            </a>
            <div [ngClass]="((varIdPerfil===1 || varIdPerfil===4) && varIdAccionCarpertaEstCredito === 2)?'col-10':'col-11'">
              <a style="text-decoration:underline;" (click)='DescargarArchivo(documento)' *ngIf="(varIdPerfil===4)">{{documento.strTipoDocumento}}</a>
              <span *ngIf="!(varIdPerfil===4)">{{documento.strTipoDocumento}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <span>{{documento.strFchImportacion}}</span>
        </div>
        <div class="col-md-3">
          <span>{{documento.strUsuarioImportacion}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
